export default __webpack_public_path__ + "static/media/longchamp14.c06f45de.jpg";